// @ts-check
import { useQuery } from '@tanstack/react-query';
import api from 'modules/queries/api';

/**
 * @param {import('club-sauce/public/contact/index.raw').LWApiPublicContactListParamsRawI} params
 * @param {object} options
 * @param {import('@tanstack/react-query').UseQueryOptions['keepPreviousData']} [options.keepPreviousData]
 * @param {import('@tanstack/react-query').UseQueryOptions['enabled']} [options.enabled]
 * @param {import('@tanstack/react-query').UseQueryOptions['retry']} [options.retry]
 */
const useContactList = (params, { keepPreviousData, enabled, retry } = {}) =>
	useQuery({
		queryKey: ['/contact/list', params],
		queryFn: () => api.contact.apiRaw.list(params),
		keepPreviousData,
		enabled,
		retry,
	});

export default useContactList;
